import { useState, useRef, useEffect } from "react";
import { PatternFormat } from "react-number-format";

import {
  Box,
  Drawer,
  Stack,
  Divider,
  Typography,
  IconButton,
  Button,
  Chip,
  CircularProgress,
  TextField,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import CloudDoneIcon from "@mui/icons-material/CloudDone";

import useHrmEmployeeStore from "../../../../../stores/hrEmployee";

const HRManagementEmployeeDocuments = () => {
  const [state, setState] = useState(false);
  const openRef = useRef(null);
  const saveDraft = useHrmEmployeeStore((state: any) => state.saveDraft);
  const changeDraft = useHrmEmployeeStore((state: any) => state.changeDraft);
  const isSaving = useHrmEmployeeStore((state: any) => state.isSaving);
  const data = useHrmEmployeeStore((state: any) => state.data);
  const addDrawersRef = useHrmEmployeeStore(
    (state: any) => state.addDrawersRef,
  );

  useEffect(() => addDrawersRef({ name: "documents", ref: openRef }), []);

  return (
    <>
      <Button
        fullWidth
        ref={openRef}
        variant="outlined"
        onClick={() => setState(true)}
        disabled={data?.status !== "editing"}
      >
        <Stack spacing={1} alignItems="center">
          <ContactPageIcon fontSize="large" />
          <div>Documentos</div>
        </Stack>
      </Button>
      <Drawer anchor="left" open={state} onClose={() => setState(false)}>
        <Box sx={{ p: 3, pt: 2, width: 400 }} height="100%">
          <Stack height="100%" spacing={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body1" sx={{ flex: 1 }}>
                Documentos
              </Typography>
              {data.status === "editing" && (
                <Chip
                  color="success"
                  variant="outlined"
                  icon={
                    isSaving ? (
                      <CircularProgress color="warning" size={18} />
                    ) : (
                      <CloudDoneIcon fontSize="small" />
                    )
                  }
                  label={isSaving ? "Salvando..." : "Tudo Salvo"}
                />
              )}
              <IconButton onClick={() => setState(false)}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <Divider />
            <TextField
              name="rg"
              fullWidth
              variant="filled"
              label="Número do RG"
              value={data.draft?.rg ?? ""}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
            />
            <TextField
              name="orgao_emissor_rg"
              fullWidth
              variant="filled"
              label="Órgão emissor do RG"
              value={data.draft?.orgao_emissor_rg ?? ""}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
            />
            <TextField
              name="estado_rg"
              fullWidth
              variant="filled"
              select
              label="UF emissor do RG"
              value={data.draft?.estado_rg ?? ""}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
            >
              <option value=""></option>
              {[
                "AC",
                "AL",
                "AM",
                "AP",
                "BA",
                "CE",
                "DF",
                "ES",
                "GO",
                "MA",
                "MG",
                "MS",
                "MT",
                "PA",
                "PB",
                "PE",
                "PI",
                "PR",
                "RJ",
                "RN",
                "RO",
                "RR",
                "RS",
                "SC",
                "SE",
                "SP",
                "TO",
              ].map((uf) => (
                <option key={uf} value={uf}>
                  {uf}
                </option>
              ))}
            </TextField>
            <PatternFormat
              format="##/##/####"
              name="data_emissao_rg"
              fullWidth
              variant="filled"
              label="Data de emissão do RG"
              value={data.draft?.data_emissao_rg ?? ""}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              customInput={TextField}
            />
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};

export default HRManagementEmployeeDocuments;
